import { getSSOToken } from 'app/state/session/helpers';

import Entry from '../entry/entry';
import LoginSSO from '../entry/sso/login-sso';

const LoginContainer = () => {
  const isSSO = !!getSSOToken();
  const Container = isSSO ? LoginSSO : Entry;

  return <Container type='login' />;
};

LoginContainer.displayName = 'LoginContainer';

export default LoginContainer;
